import React, { useEffect, useState } from "react";

import { Pie } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import url from "../../constants/URL";
import { connect } from "react-redux";
import Loading from "../Loading";
import { chartColors } from "./colors";

Chart.register(...registerables);

function SalesDashboard(props) {
  const [totalSalesAmount, setTotalSalesAmount] = useState(0);
  const [totalItemsSold, setTotalItemsSold] = useState(0);
  const [itemsSales, setItemsSales] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSales();
  }, []);

  const fetchSales = async () => {
    fetch(`${url}/sales/${props.auth.seller._id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }).then(async (resp) => {
      const sales = await resp.json();
      var total_sales_price = 0;
      var total_sales_quantity = 0;
      sales.itemSales.forEach((i) => {
        total_sales_price += i.salesAmount;
        total_sales_quantity += i.itemsSold;
      });
      setTotalItemsSold(total_sales_quantity);
      setTotalSalesAmount(total_sales_price);
      setItemsSales(sales);
      setLoading(false);
    });
  };

  if (loading) {
    return <Loading />;
  }

  var labels = [];
  var items_quantity = [];
  var items_price = [];
  itemsSales.itemSales.forEach((i) => {
    labels.push(i._id);
    items_quantity.push(i.itemsSold);
    items_price.push(i.salesAmount);
  });

  const pieData_quantity = {
    maintainAspectRatio: false,
    responsive: false,
    labels,
    datasets: [
      {
        data: items_quantity,
        backgroundColor: chartColors,
        hoverBackgroundColor: chartColors,
      },
    ],
  };
  const pieData_price = {
    maintainAspectRatio: false,
    responsive: false,
    labels,
    datasets: [
      {
        data: items_price,
        backgroundColor: chartColors,
        hoverBackgroundColor: chartColors,
      },
    ],
  };

  return (
    <div>
      <h2
        style={{
          textAlign: "center",
          backgroundColor: "lavender",
          padding: "15px",
          borderRadius: "20px",
        }}
      >
        Sales Report
      </h2>
      <div
        style={{
          fontFamily: "sans-serif",
          textAlign: "center",
          display: "flex",
          margin: "20px 0",
          justifyContent: "space-around",
        }}
      >
        <div
          style={{
            width: "40%",
          }}
        >
          <h4
            style={{
              fontWeight: "normal",
              background: "beige",
              padding: 10,
              borderRadius: 10,
            }}
          >
            Sales in PKR
          </h4>
          <Pie data={pieData_price} />
          <div
            style={{
              backgroundColor: "turquoise",
              padding: "5% 0",
              borderRadius: "20px",
              marginTop: "30px",
              color: "white",
            }}
          >
            <h4>Total Sales</h4>
            <h3>{totalSalesAmount} PKR</h3>
          </div>
        </div>
        <div
          style={{
            width: "40%",
          }}
        >
          <h4
            style={{
              fontWeight: "normal",
              background: "beige",
              padding: 10,
              borderRadius: 10,
            }}
          >
            Number of items sold
          </h4>

          <Pie data={pieData_quantity} />
          <div
            style={{
              backgroundColor: "cornflowerblue",
              padding: "5% 0",
              borderRadius: "20px",
              marginTop: "30px",
              color: "white",
            }}
          >
            <h4>Total Items Sold</h4>
            <h3>{totalItemsSold} Items</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(SalesDashboard);
